import { __read, __spread } from "tslib";
import { formatValue as valueFormatter, calculateTotalValue, } from '@keen.io/charts-utils';
import { extractGroupBySettings } from '@keen.io/query';
import { KEEN_KEY } from '@keen.io/parser';
import { calculatePercent } from '../../utils';
import { COLUMN_JOIN, VALUE, PERCENTAGE_VALUE } from '../../constants';
export var transform = function (_a) {
    var query = _a.query, chartSettings = _a.chartSettings;
    var keys = chartSettings.keys, data = chartSettings.data, tooltipSettings = chartSettings.tooltipSettings;
    var groupBy = query.group_by;
    var _b = __read(keys, 1), valueSelector = _b[0];
    var formatValue = tooltipSettings === null || tooltipSettings === void 0 ? void 0 : tooltipSettings.formatValue;
    var groupColumnName = extractGroupBySettings(groupBy).join(COLUMN_JOIN);
    var total = calculateTotalValue(data, KEEN_KEY, keys);
    var columns = [groupColumnName, VALUE, PERCENTAGE_VALUE];
    return __spread([
        columns
    ], data.map(function (item) { return [
        item[KEEN_KEY],
        valueFormatter(item[valueSelector], formatValue),
        calculatePercent(item[valueSelector], total) + "%",
    ]; }));
};
